import { createContext } from 'react';

// Define toast types and their properties
export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface Toast {
  id: string;
  type: ToastType;
  title?: string;
  message?: string;
  duration?: number; // in milliseconds
  /** Optional action button rendered inline (e.g. "Undo") */
  action?: {
    label: string;
    onClick: () => void;
  };
}

export interface ToastContextValue {
  toasts: Toast[];
  showToast: (options: Omit<Toast, 'id'>) => string;
  hideToast: (id: string) => void;
  hideAllToasts: () => void;
  // Convenience helpers
  success?: (message: string, title?: string, duration?: number) => string;
  error?: (message: string, title?: string, duration?: number) => string;
  info?: (message: string, title?: string, duration?: number) => string;
  warning?: (message: string, title?: string, duration?: number) => string;
}

// Default durations for each toast type
export const DEFAULT_DURATIONS: Record<ToastType, number> = {
  success: 5000,
  error: 8000,
  info: 5000,
  warning: 6000
};

export const ToastContext = createContext<ToastContextValue | undefined>(undefined);
